export default __webpack_public_path__ + "static/media/element_46.7ef7867c.jpg";